<template>
  <div>
    <b-form-checkbox
      v-if="!$store.state.app.isMaster($store) && canUpdateLimit && $can('update', 'lotto.limit')"
      v-model="isAutoUpdateLimitNumber"
      name="check-button"
      class="mb-2"
      switch
      inline
      @change="changeAutoUpdateLimitNumber"
    >
      Auto Update Limit
    </b-form-checkbox>
    <b-card
      style="max-width: 820px"
    >
      <b-card-text>
        <b-row
          class="justify-content-start align-items-center  text-center text-sm-left"
          no-gutters
        >
          <b-col
            sm="auto"
          >
            <span style="font-size: 1.286rem">{{ $t('อั้นตัวเลข') }} {{ huayData.name }}</span>
          </b-col>
          <b-col
            v-if="!$store.state.app.isMaster($store)"
            sm="auto"
            class="mt-50 mt-sm-0 text-center"
          >
            <b-button
              v-if="$can('update', 'lotto.limit')"
              v-ripple.400="'rgba(234, 84, 85, 0.15)'"
              variant="relief-primary"
              class="ml-50"
              @click="DownloadDefault"
            >
              <span>{{ $t('Default Setting') }}</span>
            </b-button>
          </b-col>
        </b-row>
      </b-card-text>
      <validation-observer ref="simpleRules">
        <b-form @submit.prevent>
          <b-form-group
            :label="$t('ประเภทการเเทง')"
            label-for="mc-type"
          >
            <v-select
              v-model="form.type"
              label="ประเภทการเเทง"
              :clearable="false"
              :options="$tOptions(options)"
              :get-option-label="$tDisplay"
              class="mb-1"
              append-to-body
              :placeholder="$t('ประเภทการเเทง')"
            />
          </b-form-group>
          <b-form-group
            :label="$t('เลข')"
            label-for="mc-number"
          >
            <validation-provider
              #default="{ errors }"
              name="number"
              :rules="`required|digits:${numberLimit(form.type)}`"
            >
              <b-form-input
                id="mc-number"
                v-model="form.number"
                :disabled="!form.type"
                :placeholder="$t('เลข')"
                :minlength="numberLimit(form.type)"
                :maxlength="numberLimit(form.type)"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
          <b-form-group
            :label="$t('เปอร์เซ็นที่จะจ่าย (Ex.50)')"
            label-for="percent"
          >
            <validation-provider
              #default="{ errors }"
              name="percent"
              rules="required|decimal|min_value:0|max_value:100"
            >
              <b-form-input
                id="percent"
                v-model="form.multiply"
                :disabled="!form.type"
                type="number"
                :placeholder="$t('เปอร์เซ็นที่จะจ่าย (Ex.50)')"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
          <div class="text-right">
            <b-button
              v-ripple.400="'rgba(234, 84, 85, 0.15)'"
              variant="primary"
              class="mb-1"
              type="submit"
              @click.prevent="onSubmit"
            >
              <feather-icon
                icon="PlusIcon"
                class="mr-25"
              />
              <span>{{ $t('Add') }}</span>
            </b-button>
          </div>
        </b-form>
      </validation-observer>
      <b-card-text><strong>{{ $t('รายการเลขอั้นทั้งหมด') }}</strong></b-card-text>
      <b-table
        responsive
        :fields="$tFields(fields)"
        :items="limits"
      >
        <template #cell(type)="data">
          {{ $tDisplay(betTypeLabel(data.value, options)) }}
        </template>
        <template #cell(number)="data">
          <div
            class="hintEdit"
            @click="editData(data.index,'number')"
          >
            {{ data.value }}
          </div>
        </template>
        <template #cell(multiply)="data">
          <div
            class="hintEdit"
            @click="editData(data.index,'multiply')"
          >
            {{ data.value }}
          </div>
        </template>
        <template #cell(action)="data">
          <b-button
            v-if="$can('update', 'lotto.limit')"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="warning"
            class="btn-icon rounded-circle m-0"
            size="sm"
            @click="deleteItem(data.item.id)"
          >
            <feather-icon icon="ArchiveIcon" />
          </b-button>
        </template>
      </b-table>
      <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        variant="dark"
        class="mb-50 mr-50"
        @click="$router.go(-1)"
      >
        <feather-icon
          icon="ChevronLeftIcon"
          class="mr-25"
        />
        <span>{{ $t('ย้อนกลับ') }}</span>
      </b-button>

      <b-button
        v-if="$store.state.app.isMaster($store) && $can('update', 'lotto.limit')"
        v-ripple.400="'rgba(234, 84, 85, 0.15)'"
        variant="relief-primary"
        class="ml-50 mb-50"
        @click="BroadcastUpdate"
      >
        <span>{{ $t('Broadcast Update') }}</span>
      </b-button>

      <b-button
        v-if="$can('update', 'lotto.limit')"
        v-ripple.400="'rgba(234, 84, 85, 0.15)'"
        variant="relief-danger"
        class="ml-50 mb-50"
        @click="deleteAll"
      >
        <span class="ml-25">{{ $t('Delete All') }}</span>
      </b-button>
    </b-card>

    <b-modal
      v-model="showModal"
      cancel-variant="secondary"
      ok-only
      :ok-title="$t('Ok')"
      centered
      size="xs"
      :title="$t('เเก้ไข')"
      button-size="sm"
      @ok="submitEdit"
      @hidden="modalTextError=''"
    >
      <b-form-input
        v-model="modalText"
        autofocus
        type="number"
        @keypress.enter="submitEdit"
      />
      <small
        v-if="modalTextError !== ''"
        class="text-danger"
      >{{ modalTextError }}</small>
    </b-modal>
  </div>
</template>

<script>
/* eslint-disable vue/no-unused-components,no-unused-vars */
import {
  BForm, BFormInput, BRow, BCol, BButton, BCard, BFormGroup, BTable, BCardText,
} from 'bootstrap-vue'
import vSelect from 'vue-select'

import { heightTransition } from '@core/mixins/ui/transition'
import Ripple from 'vue-ripple-directive'
import lottoService from '@/service/lottoService'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import fourFiveDigitService from '@/service/fourFiveDigitService'
import {
  FOUR_FIVE_DIGIT_LABELS, betTypeLabel, fourFiveDigitLength, fourFiveDigitNumberError, isFourFiveDigit,
  isLockedFourFiveDigit,
} from '@/utils/betTypes'
import {} from '@validations'

const { BFormCheckbox } = require('bootstrap-vue')

export default {
  components: {
    BFormCheckbox,
    BCard,
    BCardText,
    BForm,
    BRow,
    BCol,
    BButton,
    BFormInput,
    BFormGroup,
    vSelect,
    ValidationProvider,
    ValidationObserver,
    BTable,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      isAutoUpdateLimitNumber: false,
      canUpdateLimit: false,
      loaded: true,
      options: [
        'สามตัวบน',
        'สามตัวโต้ด',
        'สามตัวหน้า',
        'สามตัวท้าย',
        'สองตัวบน',
        'สองตัวล่าง',
        'วิ่งบน',
        'วิ่งล่าง',
      ],
      mapValue: {
        สามตัวบน: 1,
        สามตัวโต้ด: 2,
        สามตัวหน้า: 3,
        สามตัวท้าย: 4,
        สองตัวบน: 5,
        สองตัวล่าง: 6,
        วิ่งบน: 7,
        วิ่งล่าง: 8,
        เลขชุดสี่ตัว: 9,
        ...Object.fromEntries(Object.entries(FOUR_FIVE_DIGIT_LABELS).map(([type, label]) => [label, Number(type)])),
      },
      mapValueLimit: {
        สามตัวบน: 3,
        สามตัวโต้ด: 3,
        สามตัวหน้า: 3,
        สามตัวท้าย: 3,
        สองตัวบน: 2,
        สองตัวล่าง: 2,
        วิ่งบน: 1,
        วิ่งล่าง: 1,
        เลขชุดสี่ตัว: 4,
        ...Object.fromEntries(Object.entries(FOUR_FIVE_DIGIT_LABELS).map(([type, label]) => [label, fourFiveDigitLength(type)])),
      },
      // 4/5 ตัว: ประเภทที่เห็น · อั้นของประเภทที่ไม่เห็นไม่แสดง
      fourFiveDigitTypes: [],
      // ประเภทที่ติ๊กเปิดในหวยนี้แล้ว (ต่อท้ายตัวเลือก) · อั้นของประเภทที่เห็นแต่ยังไม่ติ๊กแก้ไม่ได้
      fourFiveDigitEditable: [],
      fourFiveDigitReady: null,
      huayData: {
        name: '',
      },
      form: {
        huayId: '',
        type: null,
        number: '',
        multiply: '',
      },
      loading: false,
      pagination: {
        rowsPerPage: 0,
      },
      fields: [
        {
          key: 'type',
          label: 'ประเภทการเเทง',
          class: 'text-nowrap',
        },
        {
          key: 'number',
          label: 'ตัวเลข',
        },
        {
          key: 'multiply',
          label: 'เปอร์เซ็นจ่าย',
          class: 'text-center text-nowrap',
        },
        {
          key: 'action',
          label: 'กระทำ',
          class: 'text-center',
        },
      ],
      limits: [],
      selectionRows: null,
      focusableObj: {
        row: 0,
        key: '',
        type: 0,
      },
      showModal: false,
      modalText: '',
      modalTextError: '',
    }
  },
  async mounted() {
    const { id } = this.$route.query
    if (id) {
      this.form.huayId = id

      if (!this.$store.state.app.isMaster(this.$store) && this.$can('update', 'lotto.limit')) {
        lottoService.getAuthen(`limit-number/auto/${id}`)
          .then(res => {
            if (res.status === 200) {
              this.isAutoUpdateLimitNumber = res.data.isAutoUpdate ?? res.data
              this.canUpdateLimit = res.data.canUpdateLimit ?? true
            }
          })
        setTimeout(() => {
          lottoService.getAuthen(`limit-number/auto/${id}`)
            .then(res => {
              if (res.status === 200) {
                this.isAutoUpdateLimitNumber = res.data.isAutoUpdate ?? res.data
                this.canUpdateLimit = res.data.canUpdateLimit ?? true
              }
            })
        }, 5000)
      }

      this.loaded = false
      // 4/5 ตัว: เห็นประเภทที่เปิดโหมดแล้ว แต่เพิ่ม/แก้ได้เฉพาะที่ติ๊กเปิดในหวยนี้
      this.fourFiveDigitReady = fourFiveDigitService.settingAccess().then(({ visible, editable }) => {
        this.fourFiveDigitTypes = visible[id] || []
        this.fourFiveDigitEditable = editable[id] || []
        this.options.push(...this.fourFiveDigitEditable.map(type => betTypeLabel(type)))
      })
      const [res] = await Promise.all([
        lottoService.getAuthen(`huay/label/${id}`),
        this.reloadTable(),
      ])

      if (res.status === 200) {
        this.huayData = res.data.huay
      }
    }
  },
  methods: {
    editData(row, key) {
      if (isLockedFourFiveDigit(this.limits[row].type, this.fourFiveDigitEditable)) return
      this.showModal = true
      this.focusableObj.row = row
      this.focusableObj.key = key
      this.modalText = this.limits[row][key]
      this.focusableObj.type = this.limits[row].type
    },
    submitEdit(bvModalEvt) {
      bvModalEvt.preventDefault()
      if (this.modalText * 1 < 0) {
        this.modalTextError = this.$t('ตัวเลขต้องมีค่าตั้งเเต่ 0 ขึ้นไป')
      } else if (this.modalText.length > 0 && this.modalText[0] === '-') {
        this.modalTextError = this.$t('กรุณากรอกตัวเลขให้ถูกต้อง')
      } else if (this.focusableObj.key === 'number' && this.modalText.length !== this.numberLimit(betTypeLabel(this.focusableObj.type, this.options))) {
        this.modalTextError = this.$t('กรุณากรอกตัวเลขให้ถูกต้อง')
      } else if (this.focusableObj.key === 'multiply' && (this.modalText * 1 < 0 || this.modalText * 1 > 100)) {
        this.modalTextError = this.$t('กรุณากรอกตัวเลขให้ถูกต้อง')
      } else {
        const {
          row,
          key,
        } = this.focusableObj

        this.$swal({
          dark: true,
          title: this.$t('Are you sure?'),
          text: this.$t('คุณเเน่ใจว่าต้องการเเก้ไขข้อมูลใช่หรือไม่'),
          icon: 'info',
          showCancelButton: true,
          confirmButtonText: this.$t('Ok'),
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-outline-danger ml-1',
          },
          buttonsStyling: false,
          onOpen: () => {
            const btn = this.$swal.getConfirmButton()
            window.addEventListener('keypress', e => {
              if (e.key === 'Enter') {
                btn.click()
              }
            })
          },
        })
          .then(async result => {
            if (result.isConfirmed) {
              const form = { ...this.limits[row] }
              form.multiply *= 1
              if (this.focusableObj.key === 'number') {
                form.number = this.modalText
              } else {
                form.multiply = this.modalText * 1
              }
              const res = await lottoService.putAuthen(`limit/${form.id}`, form)
              if (res.status === 200) {
                this.limits[row][key] = this.modalText
                this.showModal = false
                this.$toast({
                  component: ToastificationContent,
                  position: 'top-right',
                  props: {
                    title: this.$t('สำเร็จ'),
                    icon: 'CoffeeIcon',
                    variant: 'success',
                    text: this.$t('ดำเนินการสำเร็จ'),
                  },
                })
              } else {
                this.$toast({
                  component: ToastificationContent,
                  position: 'top-right',
                  props: {
                    title: this.$t('เกิดข้อผิดพลาด'),
                    icon: 'AlertCircleIcon',
                    variant: 'danger',
                    text: res.data,
                  },
                })
              }
            }
          })
      }
    },
    changeAutoUpdateLimitNumber(e) {
      this.$swal({
        dark: true,
        title: this.$t('Are you sure?'),
        text: this.$t('คุณเเน่ใจว่าต้องการดำเนินการใช่หรือไม่'),
        icon: 'info',
        showCancelButton: true,
        confirmButtonText: this.$t('Ok'),
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      })
        .then(async result => {
          if (result.isConfirmed) {
            const res = await lottoService.getAuthen(`limit-number/${this.form.huayId}`)
            if (res.status === 200) {
              this.$toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                  title: this.$t('สำเร็จ'),
                  icon: 'CoffeeIcon',
                  variant: 'success',
                  text: this.$t('ดำเนินการสำเร็จ'),
                },
              })
            } else {
              this.isAutoUpdateLimitNumber = !e
              this.$toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                  title: this.$t('เกิดข้อผิดพลาด'),
                  icon: 'AlertCircleIcon',
                  variant: 'danger',
                  text: res.data,
                },
              })
            }
          } else {
            this.isAutoUpdateLimitNumber = !e
          }
        })
    },
    async BroadcastUpdate() {
      this.$swal({
        dark: true,
        title: this.$t('Are you sure?'),
        text: this.$t('คุณเเน่ใจว่าต้องการเเจ้งอัพเดตข้อมูลไปที่ตัวเเทนทั้งหมดใช่หรือไม่'),
        icon: 'info',
        showCancelButton: true,
        confirmButtonText: this.$t('Ok'),
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      })
        .then(async result => {
          if (result.value) {
            const res = await lottoService.getAuthen(`limit-number/broadcast/${this.form.huayId}`)
            if (res.status === 200) {
              this.$toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                  title: this.$t('สำเร็จ'),
                  icon: 'CoffeeIcon',
                  variant: 'success',
                  text: this.$t('ดำเนินการสำเร็จ'),
                },
              })
            } else {
              this.$toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                  title: this.$t('เกิดข้อผิดพลาด'),
                  icon: 'AlertCircleIcon',
                  variant: 'danger',
                  text: res.data,
                },
              })
            }
          }
        })
    },
    async reloadTable() {
      this.loading = true
      const [res] = await Promise.all([
        lottoService.getAuthen(`limit/${this.form.huayId}`),
        this.fourFiveDigitReady,
      ])
      if (res.status === 200) {
        this.loading = false
        this.limits = this.visibleLimits(res.data)
      }
    },
    numberLimit(type) {
      return this.mapValueLimit[type]
    },
    betTypeLabel,
    visibleLimits(rows) {
      return (rows || []).filter(v => !isFourFiveDigit(v.type) || this.fourFiveDigitTypes.includes(v.type))
    },
    async onSubmit() {
      this.$refs.simpleRules.validate()
        .then(async success => {
          if (success) {
            const form = { ...this.form }
            // eslint-disable-next-line no-unreachable
            form.type = this.mapValue[this.form.type]
            form.multiply *= 1
            // 4/5 ตัวโต๊ดไม่รับเลขที่ทุกหลักเหมือนกัน (server กระจายอั้นให้ทุกรูปแบบการสลับเอง)
            const fourFiveDigitError = isFourFiveDigit(form.type) ? fourFiveDigitNumberError(form.type, form.number) : ''
            if (fourFiveDigitError) {
              this.$toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                  title: this.$t('เกิดข้อผิดพลาด'),
                  icon: 'AlertCircleIcon',
                  variant: 'danger',
                  text: this.$t(fourFiveDigitError),
                },
              })
              return
            }
            const res = await lottoService.postAuthen('limit', form)
            if (res.status === 200) {
              this.reloadTable()
              this.$toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                  title: this.$t('สำเร็จ'),
                  icon: 'CoffeeIcon',
                  variant: 'success',
                  text: this.$t('เพิ่มข้อมูลสำเร็จ'),
                },
              })
            } else {
              this.$toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                  title: this.$t('เกิดข้อผิดพลาด'),
                  icon: 'AlertCircleIcon',
                  variant: 'danger',
                  text: this.$t('ขัดคล่อง โปรดลองใหม่ในภายหลัง'),
                },
              })
            }
          }
        })
    },
    async editItem(row) {
      this.$swal({
        dark: true,
        title: this.$t('Are you sure?'),
        text: this.$t('คุณเเน่ใจว่าต้องการบันทึกข้อมูลใช่หรือไม่'),
        icon: 'info',
        showCancelButton: true,
        confirmButtonText: this.$t('Ok'),
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      })
        .then(async result => {
          if (result.value) {
            const res = await lottoService.putAuthen(`limit/${row.id}`, row)
            if (res.status === 200) {
              this.reloadTable()
              this.$toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                  title: this.$t('สำเร็จ'),
                  icon: 'CoffeeIcon',
                  variant: 'success',
                  text: this.$t('เเก้ไขข้อมูลสำเร็จ'),
                },
              })
            } else {
              this.$toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                  title: this.$t('เกิดข้อผิดพลาด'),
                  icon: 'AlertCircleIcon',
                  variant: 'danger',
                  text: this.$t('ขัดคล่อง โปรดลองใหม่ในภายหลัง'),
                },
              })
            }
          }
        })
    },
    async deleteItem(id) {
      this.$swal({
        dark: true,
        title: this.$t('Are you sure?'),
        text: this.$t('คุณเเน่ใจว่าต้องการลบข้อมูลใช่หรือไม่'),
        icon: 'info',
        showCancelButton: true,
        confirmButtonText: this.$t('Ok'),
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      })
        .then(async result => {
          if (result.value) {
            const res = await lottoService.deleteAuthen(`limit/${id}`)
            if (res.status === 200) {
              this.reloadTable()
              this.$toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                  title: this.$t('สำเร็จ'),
                  icon: 'CoffeeIcon',
                  variant: 'success',
                  text: this.$t('ลบข้อมูลสำเร็จ'),
                },
              })
            } else {
              this.$toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                  title: this.$t('เกิดข้อผิดพลาด'),
                  icon: 'AlertCircleIcon',
                  variant: 'danger',
                  text: this.$t('ขัดคล่อง โปรดลองใหม่ในภายหลัง'),
                },
              })
            }
          }
        })
    },
    async deleteAll() {
      this.$swal({
        dark: true,
        title: this.$t('Are you sure?'),
        text: this.$t('คุณเเน่ใจว่าต้องการลบข้อมูลทั้งหมดใช่หรือไม่'),
        icon: 'info',
        showCancelButton: true,
        confirmButtonText: this.$t('Ok'),
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      })
        .then(async result => {
          if (result.value) {
            const res = await lottoService.deleteAuthen(`limit?huayId=${this.form.huayId}`)
            if (res.status === 200) {
              this.reloadTable()
              this.$toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                  title: this.$t('สำเร็จ'),
                  icon: 'CoffeeIcon',
                  variant: 'success',
                  text: this.$t('ลบข้อมูลสำเร็จ'),
                },
              })
            } else {
              this.$toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                  title: this.$t('เกิดข้อผิดพลาด'),
                  icon: 'AlertCircleIcon',
                  variant: 'danger',
                  text: this.$t('ขัดคล่อง โปรดลองใหม่ในภายหลัง'),
                },
              })
            }
          }
        })
    },
    async DownloadDefault() {
      if (this.form.huayId === '') {
        return
      }
      this.$swal({
        dark: true,
        title: this.$t('Are you sure?'),
        text: this.$t('คุณเเน่ใจว่าต้องการใช้การตั้งค่าพื้นฐานใช่หรือไม่'),
        icon: 'info',
        showCancelButton: true,
        confirmButtonText: this.$t('Ok'),
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      })
        .then(async result => {
          if (result.value) {
            this.loaded = true
            const res = await lottoService.getAuthen(`limit/load-limit-number/${this.form.huayId}`)
            setTimeout(() => {
              if (res.status === 200) {
                this.loading = false
                this.limits = this.visibleLimits(res.data)
                this.$toast({
                  component: ToastificationContent,
                  position: 'top-right',
                  props: {
                    title: this.$t('สำเร็จ'),
                    icon: 'CoffeeIcon',
                    variant: 'success',
                    text: this.$t('ดำเนินการสำเร็จ'),
                  },
                })
              } else if (res.status === 422) {
                this.$toast({
                  component: ToastificationContent,
                  position: 'top-right',
                  props: {
                    title: this.$t('สำเร็จ'),
                    icon: 'CoffeeIcon',
                    variant: 'success',
                    text: this.$t('ดำเนินการสำเร็จ'),
                  },
                })
              } else {
                this.$toast({
                  component: ToastificationContent,
                  position: 'top-right',
                  props: {
                    title: this.$t('เกิดข้อผิดพลาด'),
                    icon: 'AlertCircleIcon',
                    variant: 'danger',
                    text: this.$t('ขออภัย เกิดความผิดพลาดบางอย่าง โปรดลองใหม่อีกครั้งในภายหลัง'),
                  },
                })
              }
              this.loaded = false
            }, 100)
          }
        })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-sweetalert.scss';
</style>
